/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MainWindowSetting.vue?vue&type=template&id=666ffe58&scoped=true&"
import script from "./MainWindowSetting.vue?vue&type=script&lang=js&"
export * from "./MainWindowSetting.vue?vue&type=script&lang=js&"
import style0 from "./MainWindowSetting.vue?vue&type=style&index=0&id=666ffe58&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666ffe58",
  null
  
)

export default component.exports